/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";

// components
import SoftBox from "components/SoftBox";
import { Box } from "@mui/material";

// example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// table
import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell";
import SoftBadge from "components/SoftBadge";
import { ACTION_TYPE_ENUM } from "enums/action-type";
import { UserService } from "../../services/userService";

const genColorAction = (value) => {
  switch (value) {
    case ACTION_TYPE_ENUM.NOT_RESPONSE:
      return "error";
    case ACTION_TYPE_ENUM.RESPONSE:
      return "success";
    default:
      return "info";
  }
};

const renderBadge = (content, color) => {
  return (
    <SoftBadge
      variant="contained"
      color={color}
      size="sm"
      badgeContent={content}
      circular
      container
    />
  );
};

const renderData = (items, setDataTable) => {
  console.log(items, "it");
  return items.map((item, index) => ({
    id: item._id,
    avatar: [
      item.name,
      {
        image: item?.avatar || "/upload.png",
      },
    ],
    email: item.email,
    phone: item.phone,
    name: item.name,
    company: item.company.name,
    action: <ActionCell item={item} setDataTable={setDataTable} />,
  }));
};

const tableData = {
  columns: [
    {
      Header: "Họ tên",
      accessor: "avatar",
      sorted: true,
      Cell: ({ value: [name, data] }) => {
        console.log(data, "ava");
        return (
          <Box display="flex" gap={1} alignItems="center">
            <Box width={50} height={50}>
              <img
                style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 12 }}
                src={data.image}
                alt={name}
                referrerPolicy="no-referrer"
                loading="lazy"
              />
            </Box>
            <Box>{name}</Box>
          </Box>
        );
      },
    },
    // {
    //   Header: "Họ tên",
    //   accessor: "name",
    //   sorted: true,
    // },
    {
      Header: "Email",
      accessor: "email",
      sorted: true,
    },
    {
      Header: "Sdt",
      accessor: "phone",
    },
    {
      Header: "Công ty",
      accessor: "company",
      sorted: true,
    },

    {
      Header: "Actions",
      accessor: "action",
      align: "right",
    },
  ],
  rows: [],
};

function Employees() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc", searchBy: "" });
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 10,
  });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const queryParams = {
        ...query,
        limit: paginationData.size,
        page: paginationData.page,
      };
      const {
        data: { items, paginate },
      } = await UserService.getAll(queryParams);
      setPaginationData((prev) => ({ ...prev, count: paginate.count, size: paginate.size }));
      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items, setDataTable),
      }));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error({ error });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default Employees;
